const GoogleActions = {
    SET_GOOGLE_PLACE_ID: 'SET_GOOGLE_PLACE_ID',

    setGooglePlaceId: (placeId) => ({
        type: GoogleActions.SET_GOOGLE_PLACE_ID,
        placeId,
        persist: true // we have to persist this, because we persist the address.
    }),

    clearGooglePlaceId: () => (dispatch) => {
        // Use thunk to reset, so local storage is synced
        dispatch(GoogleActions.setGooglePlaceId(null));
    }
};

export default GoogleActions;
